import React, { useState } from "react";
import { Select, MenuItem, ListItemText } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import SVGraphics from "../../assets/SVGraphics";

const CustomDropdown = ({
  name,
  containerClassName,
  inputClassName,
  className,
  onChange,
  data,
  label,
  value,
  placeholder,
  variant = "regular",
  icon,
  hideArrow = false, // NEW: hides the right arrow
  noOutline = false, // NEW: removes border/outline
}) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    onChange(name, newValue);
  };

  return (
    <div
      onClick={!open ? handleToggle : () => null}
      className={`flex items-center cursor-pointer justify-between box-border CustomDropdown ${containerClassName}
      ${
        !noOutline && variant === "outlined"
          ? " border border-[#484848] rounded-[8px] py-2 px-4 "
          : ""
      } ${className ?? ""} `}>
      {icon && <div className="mr-2">{icon}</div>}
      <Select
        name={name}
        value={value}
        onChange={handleSelectionChange}
        displayEmpty
        open={open}
        onClose={handleClose}
        onOpen={handleToggle}
        renderValue={(selected) => {
          if (selected === undefined) {
            return <em>{placeholder}</em>;
          }
          return (
            data.find((item) => item.value === selected)?.label || placeholder
          );
        }}
        className={inputClassName + " customDropdown text-white text-[14px]"}
        inputProps={{
          "aria-label": "Without label",
        }}
        IconComponent={() => null}>
        {variant !== "navigation" && (
          <MenuItem key={"blankinput" + label} value="">
            <div className="flex w-[1rem] justify-center items-center text-white">
              {value === undefined && (
                <CheckIcon style={{ minWidth: "15px" }} />
              )}
            </div>
            <ListItemText primary={label} />
          </MenuItem>
        )}

        {data?.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            <div className="flex w-[1rem] justify-center items-center text-white">
              {value === item.value && <CheckIcon style={{ width: "15px" }} />}
            </div>
            <ListItemText primary={item.label} />
          </MenuItem>
        ))}
      </Select>

      {/* Conditionally render the arrow */}
      {!hideArrow &&
        (variant === "outlined" ? (
          <SVGraphics
            onClick={handleToggle}
            svgname="rightArrow"
            className="w-[10px] h-[10px] mb-[2px] ml-2"
          />
        ) : variant === "navigation" ? (
          <SVGraphics
            onClick={handleToggle}
            svgname="DownChevron"
            className="w-[9px] h-[6px] ml-3"
          />
        ) : (
          <SVGraphics
            onClick={handleToggle}
            svgname="rightArrow"
            className="w-[10px] h-[10px] mb-[2px] ml-1"
          />
        ))}
    </div>
  );
};

export default CustomDropdown;
